export var DrivePadType = /*#__PURE__*/function (DrivePadType) {
  DrivePadType["DOC"] = "drive-doc";
  DrivePadType["SHEET"] = "drive-sheet";
  DrivePadType["TEXT"] = "drive-text";
  DrivePadType["SLIDE"] = "drive-slide";
  DrivePadType["PDF"] = "drive-pdf";
  DrivePadType["UNKNOWN"] = "drive-unknown";
  return DrivePadType;
}({});
//# sourceMappingURL=file-meta.interface.js.map